import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  updateSuccess: {
    id: 'SwitchLocationContactCompanyProfile.updateSuccess',
    description: 'Update success',
    defaultMessage: 'Ändring sparad',
  },
  updateError: {
    id: 'SwitchLocationContactCompanyProfile.updateError',
    description: 'Update error',
    defaultMessage: 'Något gick fel',
  },
});
